import { connect } from 'react-redux'
import Helmet from './Helmet'

const mapStateToProps = ({ trainer }) => ({
  firstName: trainer.FirstName,
  lastName: trainer.LastName,
  avatar: trainer.Photo,
  description: trainer.Description
})

export default connect(mapStateToProps, null)(Helmet)
